import dateFormats from "../../server/config/dateFormats";

/* @ngInject */
function dateValidator($rootScope, moment) {
  const organization = $rootScope.organization;

  return {
    restrict: "A",
    require: "?ngModel",
    link: function (scope, element, attrs, ctrl) {
      ctrl.$validators.dateValidator = function (modelValue, viewValue) {
        // consider empty models to be valid
        if (ctrl.$isEmpty(modelValue)) return true;

        return moment(
          viewValue,
          organization.settings.dateFormat || dateFormats[0]
        ).isValid();
      };
    },
  };
}

export default dateValidator;
